export default __webpack_public_path__ + "static/media/project-5.80a22ca6.jpg";